import { ArrowLeft } from 'lucide-react';

import { useGoBack } from '@/hooks/useGoBack';

/**
 * Sub-page header. The back button returns to the previous page via
 * browser history, falling back to the Settings store tab on a direct visit.
 */
export function SettingsHeader({ eyebrow, title, description, rightSlot }) {
	const goBack = useGoBack('/settings/store');

	return (
		<div className="space-y-6">
			<button
				type="button"
				onClick={goBack}
				className="inline-flex cursor-pointer items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground transition-colors hover:text-foreground"
			>
				<ArrowLeft className="h-3 w-3" /> Back
			</button>
			<header className="flex flex-wrap items-start justify-between gap-4">
				<div className="min-w-0">
					{eyebrow ? (
						<div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{eyebrow}</div>
					) : null}
					<h1 className="text-3xl font-extrabold tracking-tight md:text-[32px]">{title}</h1>
					{description ? <p className="mt-1.5 max-w-2xl text-base text-muted-foreground">{description}</p> : null}
				</div>
				{rightSlot ? <div className="shrink-0">{rightSlot}</div> : null}
			</header>
		</div>
	);
}
